import AboutUs from "@/components/about-us";
import MetaComponent from "@/components/common/MetaComponent";
import { trackPageMount } from "@/utils/analytics";
import { useEffect } from "react";

const metadata = {
  title: "Hubzu | About-us",
};

const AboutUsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageMount({
      pageName: "about_us_page_view",
      eventCategory: "About us Page",
      eventSource: "About us Page",
    });
  }, []);
  return (
    <>
      <MetaComponent meta={metadata} />
      <AboutUs />
    </>
  );
};

export default AboutUsPage;
